import script from "./SearchAutoComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchAutoComplete.vue?vue&type=script&setup=true&lang=js"

import "./SearchAutoComplete.vue?vue&type=style&index=0&id=2635c0e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2635c0e0"]])

export default __exports__